import {sickLeaveApi} from "@services/api.service";
import {SickLeave} from "@models/sickLeave";
import {getWorkerNumber} from "@utils/tools/worker";
import {getWorkerWorkerFormSettings} from "@services/worker.service";
import {ReportWorker} from "@models/raport";
import {ReportRowWorker} from "@app/reportPage/reportPage.component";
import {getCurrentNetworkStatus} from "@services/offlineSync.service";

const getSickLeavesByDate = async (date: string, workerNumber: string | null = null): Promise<SickLeave[]> => {
    const networkStatus = await getCurrentNetworkStatus();

    if (!networkStatus) {
        return [];
    }

    try {
        if (!workerNumber) {
            workerNumber = await getWorkerNumber();
        }

        const response: any = await sickLeaveApi.get(`sick-leaves/worker/${workerNumber}/by-date`, {
            params: {date: date},
        });

        return response.data;
    } catch (error) {
        return []
    }
}

const checkWorkerHasActiveSickLeave = async (date: string, worker: ReportWorker|ReportRowWorker | null = null): Promise<boolean> => {
    const networkStatus = await getCurrentNetworkStatus();

    if (!networkStatus) {
        if (worker && worker.hasActiveSickLeave !== undefined) {
            return worker.hasActiveSickLeave;
        } else {
            return false;
        }
    }

    const workerFormSettings = await getWorkerWorkerFormSettings(worker?.number);

    if (!workerFormSettings.block_reporting_when_active_sick_leave) {
        return false;
    }

    const sickLeaves = await getSickLeavesByDate(date, worker?.number);

    return !!sickLeaves.length;
}

export {
    getSickLeavesByDate,
    checkWorkerHasActiveSickLeave,
};
